import { useCallback, useState } from "react";
import request from "superagent";
import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import Dialog from "@avinet/adaptive-ui-core/ui/Dialog";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { LoadingMask } from "../components/Loading";
import { BACKEND_URL, SESSION_TOKEN_KEY } from "../config/config";
import { getLoggedInUser, setLoggedInUser } from "../utils/login";
import "./LoginDialog.scss";

interface LoginDialogProps {
  sessionExpired: boolean;
}

const LoginDialog = ({ sessionExpired }: LoginDialogProps) => {
  const t = useTranslate("LoginDialog");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState(() => getLoggedInUser());
  const [password, setPassword] = useState("");

  const [, setSessionToken] = useSyncedLocalStorage(SESSION_TOKEN_KEY);

  const handleLogin = useCallback(
    (e: { preventDefault: () => void }) => {
      e.preventDefault();
      setLoading(true);
      setError(false);
      request
        .post(BACKEND_URL + "api/auth/authenticate")
        .send({ email, password })
        .then((res) => {
          setLoggedInUser(email);
          setSessionToken(res.body.session_id);
        })
        .catch((err) => {
          setError(err);
          setLoading(false);
        });
    },
    [email, password, setSessionToken]
  );

  return (
    <Dialog title={t("title")}>
      <div className="login-dialog">
        {loading ? (
          <LoadingMask />
        ) : (
          <form onSubmit={handleLogin}>
            {sessionExpired ? (
              <p className="info">{t("sessionExpired")}</p>
            ) : (
              <></>
            )}
            <div className="aui-form-control aui-text">
              <label htmlFor="loginEmail">{t("email")}</label>
              <input
                id="loginEmail"
                type="text"
                name="email"
                disabled={loading}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="aui-form-control aui-text">
              <label htmlFor="loginPassword">{t("password")}</label>
              <input
                id="loginPassword"
                type="password"
                name="password"
                disabled={loading}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {!!error && <p className="error">{t("loginError")}</p>}
            <div className="btn-group">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {t("login")}
              </button>
            </div>
          </form>
        )}
      </div>
    </Dialog>
  );
};

export default LoginDialog;
